import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  getLocale,
  localeFooterLinks,
  SidebarLayout
} from '@splunk-iteng/splunk-shared-components'

import { useAppSelector } from '../../store/store'
import { AppRoutes } from '../../routes/router'
import { useFilteredNavigation } from '../../auth/useFilteredNav'

export function Dashboard() {
  const location = useLocation()
  const [error, setError] = useState('')

  const { localeData, receivedLocale } = getLocale()
  const appState = useAppSelector((state) => {
    return state.admin
  })
  const filteredNav = useFilteredNavigation(appState.navigation)
  const state = { ...appState, navigation: filteredNav }

  useEffect(() => {
    const desktopSidebar = document.querySelector('.md\\:pl-64')
      ?.previousElementSibling as HTMLElement
    const contentContainer = document.querySelector(
      '.h-screen.overflow-y-auto.md\\:pl-64'
    ) as HTMLElement

    const mobileSidebar = document.querySelector(
      '.relative.z-40.md\\:hidden'
    ) as HTMLElement

    const shouldHideSidebar =
      location.pathname.includes('/profile/logs') ||
      location.pathname.includes('/profile/pii') ||
      location.pathname.includes('/attribute-management/abac-preview')

    if (desktopSidebar) {
      desktopSidebar.style.display = shouldHideSidebar ? 'none' : ''
      desktopSidebar.style.pointerEvents = shouldHideSidebar ? 'none' : ''

      if (shouldHideSidebar) {
        contentContainer.classList.add('no-sidebar-padding')
      } else {
        contentContainer.classList.remove('no-sidebar-padding')
      }
    }

    if (mobileSidebar) {
      mobileSidebar.style.display = shouldHideSidebar ? 'none' : ''
      mobileSidebar.style.pointerEvents = shouldHideSidebar ? 'none' : ''
    }
  }, [location.pathname])

  useEffect(() => {
    localeFooterLinks(localeData, receivedLocale)
  }, [localeData, receivedLocale])

  useEffect(() => {
    // Get the query parameters from the URL
    const queryParams = new URLSearchParams(location.search)

    // Check if the error parameter is present
    const errorMessage = queryParams.get('error')
    const errorDescription = queryParams.get('error_description')

    if (errorMessage) {
      if (errorDescription) {
        setError(errorDescription)
      } else {
        setError('An unknown error occurred.')
      }
    }
  }, [location])

  let result = (
    <div className="main-login">
      <SidebarLayout state={state}>{AppRoutes(state)}</SidebarLayout>
    </div>
  )
  if (error) {
    result = (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h1>Error: {error}</h1>
        <p>
          Please contact support if you believe this is an issue with your
          account.
        </p>
      </div>
    )
  }
  return result
}
